import { RemoteGetAddressViaZipCode } from 'data/usecases/locations';
import { GetAddressViaZipCodeUseCaseInterface } from 'domain/usecases';
import { makeExternalApiUrlZipCode } from 'main/factories/http/api-url-factory';
import { makeAxiosHttpClient } from 'main/factories/http/axios-http-client-factory';

export const makeGetAddressViaZipCode =
  (): GetAddressViaZipCodeUseCaseInterface =>
    new RemoteGetAddressViaZipCode(
      makeExternalApiUrlZipCode(),
      makeAxiosHttpClient(),
    );
